import React from 'react';
import { Box, BoxProps } from '@mui/material';
import ICONS, { IconName, IconScope } from 'images/icons';

interface Props extends BoxProps {
  name: string | IconName;
  color?: string;
  width?: string | number;
  height?: string | number;
  scope?: IconScope;
  viewBox?: string;
}

const CustomIcon: React.FC<Props> = ({
  name,
  color = 'currentColor',
  scope = 'common',
  width = 20,
  height = 20,
  viewBox: initialViewBox,
  sx,
  ...rest
}) => {
  if (!ICONS[scope]?.[name]) return null;

  const path = ICONS[scope][name];

  const viewBox = initialViewBox || `0 0 ${width} ${height}`;

  const iconPaths = Array.isArray(path)
    ? { dangerouslySetInnerHTML: { __html: path.join('') } }
    : { dangerouslySetInnerHTML: { __html: path } };

  return (
    <Box
      component="svg"
      position="relative"
      fill="currentColor"
      flexShrink={0}
      sx={{ color, ...sx }}
      width={`${width}px`}
      height={`${height}px`}
      version="1.1"
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      {...iconPaths}
      {...rest}
    />
  );
};

export default CustomIcon;
